export const COMMERCIAL_NO_MENTOR_HEADING = "We couldn't find a mentor right now";
export const COMMERCIAL_NO_MENTOR_BODY =
  "We're sorry — no mentor is available for this match at the moment. Please check back soon.";
export const CLINICAL_NO_MENTOR_HEADING = 'Thank you for completing your questionnaire.';
export const CLINICAL_NO_MENTOR_BODY =
  'PatientPartner will be in contact with you shortly to complete your mentor match.';

// Treat a valid <qr-code value="..."> element as non-blank content even when
// all other markup would strip down to an empty string.
const QR_CODE_PATTERN = /<qr-code\b[^>]*\bvalue\s*=\s*["'][^"']+["']/i;

const isBlank = (value) => {
  if (value == null) return true;

  const raw = String(value);
  if (QR_CODE_PATTERN.test(raw)) return false;

  return (
    raw
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/gi, ' ')
      .trim() === ''
  );
};

// Mirrors QuestionnaireQuestion#no_mentor_heading / #no_mentor_body so the
// builder preview can resolve unsaved heading/body against the same defaults
// the API uses. The member-facing flow always renders the server-computed
// no_mentor_* fields rather than calling this.
export const resolveNoMentorCopy = ({ heading, body, accountType } = {}) => {
  if (!isBlank(heading) || !isBlank(body)) {
    return { heading: heading || '', body: body || '' };
  }

  if (accountType === 'clinical_study') {
    return { heading: CLINICAL_NO_MENTOR_HEADING, body: CLINICAL_NO_MENTOR_BODY };
  }

  return { heading: COMMERCIAL_NO_MENTOR_HEADING, body: COMMERCIAL_NO_MENTOR_BODY };
};
